import { makeRemoteAccountEnrollmentDetail } from '@/main/factories/usecases/account/remote-account-enrollment-factory'
import BaseLoader from '../loaders/base-loader'
import { QueryClient } from 'react-query'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { Account } from '@/domain/usecases'
import { RemoteAccountEnrollmentDetail } from '@/data/usecases/account/remote-account-enrollment'

export default class UserEnrollmentDetailLoader extends BaseLoader {
  private remoteAccountEnrollment

  constructor(
    readonly queryClient: QueryClient,
    readonly ldClient: LDClient | undefined,
    readonly account: Account.Model
  ) {
    super(account, undefined, queryClient)
    this.remoteAccountEnrollment = makeRemoteAccountEnrollmentDetail(this.queryClient)
  }

  async loader(args?: { params?: { enrollmentId?: string } }) {
    const enrollmentId = args?.params?.enrollmentId
    const enrollmentDetail = await this.getEnrollmentDetailById(enrollmentId || '')

    return this.deferExec({
      ...enrollmentDetail
    })
  }

  async getEnrollmentDetailById(
    enrollmentId: string
  ): Promise<RemoteAccountEnrollmentDetail.Model> {
    const enrollment = (await this.remoteAccountEnrollment.loader(
      enrollmentId
    )) as RemoteAccountEnrollmentDetail.Model
    return enrollment
  }
}
